import React from 'react';
import universal from 'react-universal-component';

import 'Utilities/texts';
import 'Utilities/dayjs';
import 'swiper/css/bundle';

import { Toaster } from '@motorway/mw-highway-code/pre-alpha';

import { ScrollToTop } from 'Containers/app/ScrollToTop';

import Theme from '../../components/legacy/theme/Theme';
import { BreakpointProvider } from '../../components/misc/Breakpoints/Breakpoints';
import CookieWarning from '../../components/misc/CookieWarning/CookieWarning';

import { AffiliateHeaderContainer } from './affiliate/AffiliateHeaderContainer';
import { Header } from './header/Header';
import { GetTheAppBanner } from './homepage/Components/GetTheAppBanner/GetTheAppBanner';
import { Init } from './init/Init';
import { Routes } from './routes/Routes';

import '@motorway/mw-highway-code/src/styles/theme/light.scss';
import './DarkTheme.scss';
import 'Storybook/styles/light.scss'; // Local Storybook
import './App.scss';

/**
 * START CDN FILES
 * Import any files you want on the CDN
 * - to not babelify them, add to 'ignore' in 'babel.config.js'
 * - to not include them in webpack add them to 'webpack.common.config.js' where the CDN comment is in rules
 * - add the 3rd party scripts to the .eslintignore file
 */

import(`../../../copy_to_public_root/scripts/${process.env.SNOWPLOW_FILE}`);
import(`../../../copy_to_public_root/scripts/${process.env.SNOWPLOW_FILE}.map`);

/**
 * END CDN FILES
 */

const DevelopersWidget = process.env.APPLICATION_ENVIRONMENT !== 'production'
  ? universal(() => import('./developersWidget/DevelopersWidget'), { ignoreBabelRename: true })
  : () => null;

export const App = ({ hasError }) => (
  <>
    <ScrollToTop />
    <Toaster />
    <Init />
    <Theme>
      <BreakpointProvider>
        <DevelopersWidget />
        <GetTheAppBanner />
        <AffiliateHeaderContainer />
        <Header />
        <Routes {...{ hasError }} />
        <CookieWarning />
        <div id="modal-root" />
      </BreakpointProvider>
    </Theme>
  </>
);
